import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContactResponse } from "../../../types/common";
import { loadAccountInfosFromSession, saveAccountInfosToSession } from "./cache";
import { getContactByAccountName, getContactsByAccountNames } from "./thunks";

export type AccountInfoState = ContactResponse[];

const initialState: AccountInfoState = loadAccountInfosFromSession();

const accountInfoSlice = createSlice({
    name: "accountInfos",
    initialState,
    reducers: {
        setAccountInfos(state, action: PayloadAction<ContactResponse[]>) {
            const next = action.payload;
            saveAccountInfosToSession(next);
            return next;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getContactByAccountName.fulfilled, (state, action) => {
            const accountName = action.meta.arg;

            const exists = state.some((it) => it.accountName === accountName);
            if (exists) return;

            state.push(action.payload);
            saveAccountInfosToSession(state);
        });
        builder.addCase(getContactsByAccountNames.fulfilled, (state, action) => {
            for (const item of action.payload) {
                const exists = state.some(it => it.accountName === item.accountName);
                if (!exists) state.push(item);
            }
            saveAccountInfosToSession(state);
        });
    },
});

const { setAccountInfos } = accountInfoSlice.actions;

const accountInfoReducer = accountInfoSlice.reducer;

export { setAccountInfos };
export default accountInfoReducer;
